import React, { Component } from 'react'
import Backdrop from '../../Backdrop/Backdrop'
import classes from './Sidebar.module.css'
import {Link} from "react-router-dom"
import {connect } from 'react-redux'
import * as actions from '../../../Store/Action/index'
import NavigationItem from '../NavigationItems/NavigationItem/NavigationItem'
class Sidebar extends Component{
    render(){
    let attachedClasses = [classes.Sidebar,classes.close]
    if(this.props.show){
        attachedClasses = [classes.Sidebar,classes.open]
    }
    let value= null
    if(!this.props.isAuth){
       value = {"display":"none"}
    }
    return(
       <div>

            <Backdrop show={this.props.show} ModalClosed={this.props.ModalClosed}/>
        <div className={attachedClasses.join(" ")} onClick = {this.props.ModalClosed}>
            {/* <div className={classes.Logo}><Logo/></div> */}
            <nav>
            <ul className={classes.NavigationItems}>
            
            <NavigationItem to={"/search/git"}>Books</NavigationItem>
            <NavigationItem to={"/course-material"}>Study Material</NavigationItem>
           <div className={classes.icons}><Link to= '/'>
               <i className="fa fa-search"></i>     
           </Link>
           </div>
           <div className={classes.icons}>
             <Link to = "/register"> <i className="fa fa-user"></i>   </Link>  
             
           </div>
           <div className={classes.icons} style = {value}>
             <i onClick = {this.props.logout} className="fa fa-sign-out"> </i>  
           </div>
           
           
        </ul>
            </nav>
        </div>
        </div>
    );
    }
} 
const mapStateToProps = (state)=>{
    return{
        isAuth:state.auth.isAuth
    }
}
const mapDispatchToProps = (dispatch)=>{
    return{
        logout:()=>dispatch(actions.logout())
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Sidebar)